module.exports = "<h1>\r\n  Refund Policy\r\n  </h1>\r\n  <p>\r\n   Here's how it works : \r\n  </p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/refund-policy/refund-policy.component.html
// module id = ./src/app/refund-policy/refund-policy.component.html
// module chunks = main